const optionHasError = option => !option.type;

export const ensureGoodShippingOptions = shippingOptions => {
    shippingOptions = shippingOptions || [];
    return shippingOptions.find(optionHasError) ? [] : shippingOptions;
};
